// Adapter de desarrollo: imprime en consola EXACTAMENTE el payload que se
// enviaría, ya saneado. Es la herramienta de QA de privacidad: permite auditar
// qué sale sin necesidad de cuenta, key ni pestaña Network.
import type { AnalyticsAdapter, EmitOptions, SafeProps } from "../types";

const LABEL = "color:#22c55e;font-weight:bold";

export function createConsoleAdapter(): AnalyticsAdapter {
  let superProps: SafeProps = {};

  const log = (kind: string, name: string, payload: unknown): void => {
    // eslint-disable-next-line no-console
    console.info(`%c[analytics:${kind}]%c ${name}`, LABEL, "", payload);
  };

  return {
    name: "console",

    init() {
      log("init", "listo", {});
    },

    track(event, props, opts?: EmitOptions) {
      log("track", event, { ...superProps, ...props, _flush: Boolean(opts?.flush) });
    },

    page(screen, props) {
      log("page", screen, { ...superProps, ...props });
    },

    identify(distinctId, traits) {
      log("identify", distinctId, traits);
    },

    register(props) {
      superProps = { ...superProps, ...props };
      log("register", "super properties", props);
    },

    reset() {
      superProps = {};
      log("reset", "-", {});
    },
  };
}
